import { formatEther } from 'viem'
import { getUnixTime, sub } from 'date-fns'
import { gql } from 'graphql-request'
import { GetStaticProps } from 'next'
import { SWRConfig } from 'swr'
import { getCakeVaultAddress } from 'utils/addressHelpers'
import { getCakeContract } from 'utils/contractHelpers'
import { getBlocksFromTimestamps } from 'utils/getBlocksFromTimestamps'
import { bitQueryServerClient, infoServerClient } from 'utils/graphql'
import { useProtocolData } from 'views/V3Info/hooks'
import { formatDollarAmount } from 'views/V3Info/utils/numbers'
// import Home from '../views/Home'
import { useRouter } from 'next/router'
// import Info from './info/v3/index'
import styled from 'styled-components'
import { useCallback, useEffect, useRef, useState } from 'react'
import { SdkProvider } from 'gby-sdk'
import FooterNew from '../components/FooterNew'
import { Button } from '../componentsNew'

const XScroll = styled.div`
  @media not screen and (max-width: 1280px) {
    width: 100%;
    overflow-x: scroll;
  }
  @media screen and (max-width: 1280px) {
    width: 100%;
  }
`
const Wrapper = styled.div`
  @media not screen and (max-width: 1280px) {
    min-width: 1440px;
    width: 100vw;
    .banner {
      padding: 120px 0 156px 0;
      min-height: 100vh;
      background-image: url('/newImages/home/home_bg.png');
      background-size: cover;
      background-position: center;
      background-repeat: no-repeat;
      .inner {
        position: relative;
        margin: 0 auto;
        width: 1200px;
      }
      .areas {
        position: relative;
        width: 756px;
        z-index: 1;
        h2 {
          padding-bottom: 16px;
          color: #fff;
          font-size: 80px;
          font-style: italic;
          font-weight: 900;
          line-height: 80px; /* 80px */
        }
        .tips {
          margin: 24px 0 86px 0;
          color: var(---T1, #fff);
          font-size: 20px;
          line-height: 26px; /* 26px */
        }
        .button {
          width: max-content;
          min-width: 200px;
          height: 65px;
          padding: 0 40px;
          border-radius: 32px;
          background: #f4c470;
          box-shadow: 0px 24px 40px 0px rgba(55, 29, 19, 0.25);
          text-align: center;
          color: var(---, #000);
          font-size: 28px;
          font-weight: 700;
          line-height: 65px;
          user-select: none;
          cursor: pointer;
          transition: all 0.3s ease-in-out;
          &:hover {
            opacity: 0.8;
          }
        }
      }
      .mascot {
        position: absolute;
        top: -120px;
        left: 520px;
        width: 800px;
        height: 500px;
      }
      .total {
        margin-top: 120px;
        position: relative;
        gap: 80px;
        padding: 48px;
        border-radius: 24px;
        background: var(---BG01, #000);
        box-shadow: 0px 24px 32px 0px rgba(0, 0, 0, 0.25);
        z-index: 1;
        div {
          flex: 1;
        }
        h4 {
          color: var(---T1, #fff);
          text-align: center;
          font-size: 40px;
          font-weight: 700;
          line-height: 100%; /* 40px */
        }
        p {
          margin-top: 16px;
          text-align: center;
          color: var(---T4, #737373);
          font-size: 14px;
          font-weight: 400;
          line-height: 100%; /* 14px */
          text-transform: capitalize;
        }
      }
    }
  }
  @media screen and (max-width: 1280px) {
    width: 100vw;
    .banner {
      padding: 38px 0 156px 0;
      min-height: 100vh;
      background-image: url('/newImages/home/home_bg.png');
      background-size: cover;
      background-position: center;
      background-repeat: no-repeat;
      .inner {
        position: relative;
        margin: 0 auto;
        width: 100vw;
      }
      .areas {
        position: relative;
        padding: 0 22px;
        width: 100%;
        z-index: 1;
        h2 {
          padding-bottom: 16px;
          text-align: center;
          color: #fff;
          font-size: 48px;
          font-style: italic;
          font-weight: 900;
          line-height: 80px; /* 80px */
        }
        .tips {
          margin: 16px 0 32px 0;
          text-align: center;
          color: var(---T1, #fff);
          font-size: 20px;
          line-height: 130%;
        }
        .button {
          margin: 0 auto;
          width: max-content;
          height: 48px;
          padding: 0 32px;
          border-radius: 32px;
          background: #f4c470;
          box-shadow: 0px 24px 40px 0px rgba(55, 29, 19, 0.25);
          text-align: center;
          color: var(---, #000);
          font-size: 20px;
          font-weight: 700;
          line-height: 48px;
          user-select: none;
        }
      }
      .mascot {
        margin: 36px auto 40px auto;
        width: 375px;
      }
      .total {
        margin: 0 12px;
        gap: 8px;
        padding: 18px 12px;
        border-radius: 8px;
        background: var(---BG01, #000);
        box-shadow: 0px 24px 32px 0px rgba(0, 0, 0, 0.25);
        div {
          flex: 1;
        }
        h4 {
          color: var(---T1, #fff);
          text-align: center;
          font-size: 16px;
          font-weight: 700;
          line-height: 100%; /* 40px */
        }
        p {
          margin-top: 8px;
          text-align: center;
          color: var(---T4, #737373);
          font-size: 10px;
          font-weight: 400;
          line-height: 100%; /* 14px */
          text-transform: capitalize;
        }
      }
    }
  }
`

const HomePage = () => {
  const router = useRouter()

  const [data, setData] = useState<
    | {
        totalValue: string
        totalTradingVolume: string
        totalStakers: string
      }
    | undefined
  >(undefined)

  const fetchData = useCallback(() => {
    SdkProvider.getApi()
      .dashBoardApi()
      .index(SdkProvider.currentChainType)
      .then((res) => {
        setData(res)
      })
  }, [])
  useEffect(() => {
    fetchData()
  }, [])

  return (
    <XScroll>
      <Wrapper>
        <div className="banner">
          <div className="inner">
            <div className="areas">
              <h2>PerpStreet</h2>
              <p className="tips">
                Trade with 1000x leverage on perpetual contracts in a secure, decentralized exchange.
              </p>
              <div
                className="button"
                onClick={() => {
                  router.push('/perp/trade')
                }}
                aria-hidden
              >
                Launch APP
              </div>
            </div>
            <div className="mascot">
              <img src="/newImages/home/home_img.png" alt="icon" />
            </div>
            {false && (
              <div className="total flex flex-row items-center justify-start">
                <div>
                  <h4>{formatDollarAmount(parseFloat(data?.totalValue ?? '0'))}</h4>
                  <p>TOTAL VALUE LOCKED</p>
                </div>
                <div>
                  <h4>{formatDollarAmount(parseFloat(data?.totalTradingVolume ?? '0'))}</h4>
                  <p>TOTAL TRADING VOLUME</p>
                </div>
                <div>
                  <h4>{formatDollarAmount(parseFloat(data?.totalStakers ?? '0'))}</h4>
                  <p>HOLDERS</p>
                </div>
              </div>
            )}
          </div>
        </div>
        <FooterNew />
      </Wrapper>
    </XScroll>
  )
}

const IndexPage = ({ totalTx30Days, addressCount30Days, tvl }) => {
  // const router = useRouter()

  // useEffect(() => {
  //   if (router.pathname === '/') {
  //     router.push('/info/v3')
  //   }
  // }, [router])

  // return null

  return (
    <SWRConfig
      value={{
        fallback: {
          totalTx30Days,
          addressCount30Days,
          tvl,
        },
      }}
    >
      {/* <Home /> */}
      {/* <Info /> */}
      <HomePage />
    </SWRConfig>
  )
}

// Values fetched from TheGraph and BitQuery jan 24, 2022
const txCount = 54780336
const addressCount = 4425459

const tvl = 6082955532.115718

export const getStaticProps: GetStaticProps = async () => {
  const totalTxQuery = gql`
    query TotalTransactions($block: Block_height) {
      pancakeFactory(block: $block) {
        totalTransactions
      }
    }
  `

  const days30Ago = sub(new Date(), { days: 30 })

  const results = {
    totalTx30Days: txCount,
    addressCount30Days: addressCount,
    tvl,
  }

  try {
    const [days30AgoBlock] = await getBlocksFromTimestamps([getUnixTime(days30Ago)])

    if (!days30AgoBlock) {
      throw new Error('No block found for 30 days ago')
    }

    const totalTx = await infoServerClient.request<any>(totalTxQuery)
    const totalTx30DaysAgo = await infoServerClient.request<any>(totalTxQuery, {
      block: {
        number: days30AgoBlock.number,
      },
    })

    if (
      totalTx?.pancakeFactory?.totalTransactions &&
      totalTx30DaysAgo?.pancakeFactory?.totalTransactions &&
      parseInt(totalTx.pancakeFactory.totalTransactions) > parseInt(totalTx30DaysAgo.pancakeFactory.totalTransactions)
    ) {
      results.totalTx30Days =
        parseInt(totalTx.pancakeFactory.totalTransactions) - parseInt(totalTx30DaysAgo.pancakeFactory.totalTransactions)
    }
  } catch (error) {
    if (process.env.NODE_ENV === 'production') {
      console.error('Error when fetching total tx count', error)
    }
  }

  const usersQuery = gql`
    query userCount($since: ISO8601DateTime, $till: ISO8601DateTime) {
      ethereum(network: bsc) {
        dexTrades(exchangeName: { in: ["Pancake", "Pancake v2"] }, date: { since: $since, till: $till }) {
          count(uniq: senders)
        }
      }
    }
  `

  if (process.env.BIT_QUERY_HEADER) {
    try {
      const result = await bitQueryServerClient.request<any>(usersQuery, {
        since: days30Ago.toISOString(),
        till: new Date().toISOString(),
      })
      if (result?.ethereum?.dexTrades?.[0]?.count) {
        results.addressCount30Days = result.ethereum.dexTrades[0].count
      }
    } catch (error) {
      if (process.env.NODE_ENV === 'production') {
        console.error('Error when fetching address count', error)
      }
    }
  }

  try {
    const result = await infoServerClient.request<any>(gql`
      query tvl {
        pancakeFactories(first: 1) {
          totalLiquidityUSD
        }
      }
    `)
    const cake = await (await fetch('https://farms-api.pancakeswap.com/price/cake')).json()
    const { totalLiquidityUSD } = result.pancakeFactories[0]
    const cakeVaultV2 = getCakeVaultAddress()
    const cakeContract = getCakeContract()
    const totalCakeInVault = await cakeContract.read.balanceOf([cakeVaultV2])
    results.tvl = parseFloat(formatEther(totalCakeInVault)) * cake.price + parseFloat(totalLiquidityUSD)
  } catch (error) {
    if (process.env.NODE_ENV === 'production') {
      console.error('Error when fetching tvl stats', error)
    }
  }

  return {
    props: results,
    revalidate: 60 * 60 * 24 * 30, // 30 days
  }
}

IndexPage.chains = []

export default IndexPage
